import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=20ae313e&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=20ae313e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae313e",
  null
  
)

export default component.exports